import { render, staticRenderFns } from "./BlindUserDetailPage.vue?vue&type=template&id=88c60318&scoped=true"
import script from "./BlindUserDetailPage.vue?vue&type=script&lang=js"
export * from "./BlindUserDetailPage.vue?vue&type=script&lang=js"
import style0 from "./BlindUserDetailPage.vue?vue&type=style&index=0&id=88c60318&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c60318",
  null
  
)

export default component.exports